// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Header_wrap__y5Nt6"};